export default "__VITE_ASSET__eyAS4NX7__"